import styled from "styled-components";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";
import { theme } from "styled-tools";

export const OverLay = styled.div`
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: ${(props) => (props.hidden ? "none" : "initial")};
`;

export const ModalWrap = styled.div`
  margin: 10px auto;
  padding: 30px;
  background: ${theme("White")};
  width: 350px;
  border-radius: 45px;
  box-shadow: 0 0 50px rgba(${theme("RGBA_01")}, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQuery[Screen.sm]} {
    width: 75%;
    max-width: 374px;
    padding: 45px 10px;
  }

  ${mediaQuery[Screen.xs]} {
    width: 85%;
    max-width: 374px;
    padding: 45px 10px;
  }
`;

export const HeadModal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 0 0 0;
`;

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterModal = styled.div`
  display: flex;
  flex-direction: column;

  button:nth-child(1) {
    margin: 0 48px 32px 48px;
    padding: 16px 32px;
  }

  button:nth-child(2) {
    margin: 0 48px 32px 48px;
    padding: 10px 32px;
  }
`;

export const ButtonOutline = styled.button`
  border-radius: 30px;
  border: 2px solid ${theme("Primary_600")};
  background: ${theme("White")};
  color: ${theme("Primary_600")};
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;

  padding-block: 10px;
`;
